import styles from "./HomePage.module.scss";
import GetInTouchSection from "./GetInTouchSection/GetInTouchSection";
import useAppSelector from "../../hooks/useAppSelector";
import FAQsSection from "./FAQsSection/FAQsSection";
import HeroSection from "./HeroSection/HeroSection";
import VenuesSection from "./VenuesSection/VenuesSection";
import TrainersSection from "./TrainersSection/TrainersSection";
import ServicesSection from "./ServicesSection/ServicesSection";
import PlansSection from "./PlansSection/PlansSection";
import MobileAppSection from "./MobileAppSection/MobileAppSection";

const HomePage = () => {

    const {content} = useAppSelector(state => state.siteContentSlice);

    return (
        <div className={styles.page}>
            <HeroSection/>
            {
                content.venuesVisible && content.venuesItems ? (
                    <VenuesSection/>
                ) : null
            }
            {
                content.trainersVisible && content.trainersItems ? (
                    <TrainersSection/>
                ) : null
            }
            {
                content.servicesVisible && content.servicesItems ? (
                    <ServicesSection/>
                ) : null
            }
            {
                content.plansVisible && content.plansItems.length ? (
                    <PlansSection/>
                ) : null
            }
            {
                content.mobileAppVisible ? (
                    <MobileAppSection/>
                ) : null
            }
            {
                content.faqVisible && content.faqItems ? (
                    <FAQsSection/>
                ) : null
            }
            {
                content.getItTouchVisible ? (
                    <GetInTouchSection/>
                ) : null
            }

        </div>
    )
}

export default HomePage;